import { NavLink, Outlet, useNavigate } from "react-router-dom"
import { setupLinks } from "../../entries"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { BreadCrumbsGeneral } from "../../components/NavigationComponents"
import { PermissionContext } from "../../contexts/PermissionContexts"


export const SetupPage = () => {
    const { t } = useTranslation('settings')
    return (
        <div className="flex flex-col justify-start items-center w-full py-2 gap-5 pb-10 px-4 h-full">
            <div className="w-full">
                <h1 className="text-xl font-semibold">{t('Setup')}</h1>
                <SidebarLayout links={setupLinks} />
            </div>

        </div>
    )
}


const SidebarLayout = ({ links }) => {
    const { t } = useTranslation('settings')

    const { hasPermission } = useContext(PermissionContext)
    const [breadCrumbs, setBreadCrumbs] = useState(
        [
            {
                link: "/admin/dashboard",
                name: t("Home")
            },
            {
                link: "/admin/setup/quick-replies",
                name: t("Setup")
            },
            {
                link: null,
                name: t('Quick Replies')
            }
        ]
    )
    const navigator = useNavigate()

    useEffect(() => {
        if (window.location.pathname == "/admin/setup") {
            navigator("/admin/setup/quick-replies")
        }
    }, [])

    const getTitle = (title) => {
        setBreadCrumbs((prev) => {
            prev.pop()
            return [...prev, {
                link: null,
                name: title
            }]
        })
    }

    return (
        <>
            <BreadCrumbsGeneral elements={breadCrumbs} />
            <div className="flex w-full py-3">
                {/* Options Navigation */}
                <div className="w-80 flex flex-col join join-vertical shadow-md h-fit">
                    {
                        links.map((link, index) =>
                            hasPermission(link.permission) &&
                            <NavigationLink key={index} props={link} getTitle={getTitle}/>
                        )
                    }
                </div>
                {/* Options View Page */}
                <div className="flex  flex-col w-full px-2 h-full">
                    <Outlet />
                </div>

            </div>
        </>
    )
}



export const NavigationLink = ({ props, getTitle }) => {
    const { t } = useTranslation('settings')
    return (
        <NavLink className="join-item btn border-none bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600"
            to={props.link}
            onClick={() => getTitle(t(props.title))}
            style={({ isActive }) => {
                return {
                    background: isActive
                        ? "#145388"
                        : "",
                    color: isActive ? "rgb(250 250 250)" : "",
                };
            }}
        >
            <span>{t(props.title)}</span>
        </NavLink>
    )
}